<div *ngIf="timestampedData$ | async as timestampedData" class="business-license">
  <h1>{{ timestampedData.title }}</h1>
  <h2>{{ 'businessLicense.latestUpdated' | cxTranslate }} {{ timestampedData?.updateDate | date: 'yyyy/LL/dd' }}</h2>
</div>
